module.exports = __webpack_public_path__ + "assets/images/activity_g.1466aa74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/activity_g.png
// module id = 669
// module chunks = 1